import appReducer from '../reducers'
import thunk from 'redux-thunk'
import { applyMiddleware, compose, createStore } from 'redux'
import { routerMiddleware } from 'connected-react-router'
// import { createLogger } from 'redux-logger'
import { persistStore, autoRehydrate } from 'redux-persist'
import { asyncSessionStorage } from 'redux-persist/storages'
import { REHYDRATE } from 'redux-persist/constants'
import createActionBuffer from 'redux-action-buffer'

import history from './history'

const configureStore = initialState => {
  let createStoreWithMiddleware
  // const logger = createLogger()
  const browserMiddleware = routerMiddleware(history)
  const middleware =
    process.env.NODE_ENV !== 'production'
      ? applyMiddleware(
          thunk,
          // logger,
          browserMiddleware,
          createActionBuffer(REHYDRATE)
        )
      : applyMiddleware(thunk, browserMiddleware, createActionBuffer(REHYDRATE))

  createStoreWithMiddleware = compose(autoRehydrate(), middleware)

  const store = createStoreWithMiddleware(createStore)(
    appReducer(history),
    initialState,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__({trace: true})
  )
  // https://github.com/rt2zz/redux-persist/issues/107
  persistStore(
    store,
    {
      storage: asyncSessionStorage,
      blacklist: ['router', 'loom', 'unsavedwork']
    }
  )

  return { store, history }
}

export default configureStore
